import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteChat",
  tabindex: "-1",
  "aria-labelledby": "deleteChat",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteChat"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "text-center my-4" }
const _hoisted_8 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_9 = {
  class: "modal fade",
  id: "deleteChatSuccess",
  tabindex: "-1",
  "aria-labelledby": "deleteChatSuccess",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "modal-dialog" }
const _hoisted_11 = { class: "modal-content" }
const _hoisted_12 = { class: "modal-header" }
const _hoisted_13 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteChatSuccess"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_15 = { class: "text-center my-4" }
const _hoisted_16 = { class: "modal-footer d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { useStore } from 'vuex'
import { computed, ComputedRef } from 'vue-demi'
import { CHAT_STORE } from '@/store/constants'
import { useRoute } from 'vue-router'
import { Modal } from 'bootstrap'
import { onMounted, ref } from 'vue'
import chatService from '@/services/chat.services'

export default /*#__PURE__*/_defineComponent({
  props: {
  isTalkRoom: {
    type: Boolean,
  },
  isDirectChat: {
    type: Boolean,
  },
  title: {
    type: String,
    default: translate('deleteChat'),
  },
},
  setup(__props) {

const props = __props

const loadingSubmit = ref(false)

const modalCompleted = ref()
const modalConfirm = ref()



const store = useStore()
const route = useRoute()

const messageId = computed<ComputedRef<string>>(() => store.getters[CHAT_STORE.GETTERS.GET_MESSAGE_ID])
const handleErrorDelete = ref<boolean>(false)
const deleteMessage = async (): void => {
  loadingSubmit.value = true
  if (props.isTalkRoom) {
    try {
      let payload = {
        talkroom_id: route.params?.talkroom_id,
        payload: {
          content_id: messageId.value,
          create_by_admin: route.path.includes('admin'),
        },
      }
      const data = await chatService.deleteMessageTalkRoom(payload)
      if (data.status === 200) {
        await store.commit(CHAT_STORE.MUTATIONS.REMOVE_MESSAGE_TALK_ROOM, payload.payload.content_id)
        handleErrorDelete.value = false
      } else handleErrorDelete.value = true
      modalConfirm.value?.hide()
      modalCompleted.value?.show()
      setTimeout(() => {
        loadingSubmit.value = false
      }, 2000)
    } catch (error) {
      modalConfirm.value?.hide()
      modalCompleted.value?.show()
      handleErrorDelete.value = true
      setTimeout(() => {
        loadingSubmit.value = false
      }, 2000)
    }
  } else if (props.isDirectChat) {
    await store.dispatch(CHAT_STORE.ACTIONS.REMOVE_DIRECT_MESSAGE, {
      chatroom_id: route.params?.chatroom_id,
      content_id: messageId.value,
      community_id: route.params?.id,
      params: {
        create_by_admin: route.path.includes('admin'),
      },
    })
    modalConfirm.value?.hide()
    modalCompleted.value?.show()
    setTimeout(() => {
      loadingSubmit.value = false
    }, 2000)
  } else {
    await store.dispatch(CHAT_STORE.ACTIONS.REMOVE_MESSAGE, {
      chatroom_id: route.params?.chatroom_id,
      content_id: messageId.value,
      params: {
        create_by_admin: route.path.includes('admin'),
      },
    })
    modalConfirm.value?.hide()
    modalCompleted.value?.show()
    setTimeout(() => {
      loadingSubmit.value = false
    }, 2000)
  }
}

onMounted(() => {
  modalCompleted.value = new Modal(document.getElementById('deleteChatSuccess'))
  modalConfirm.value = new Modal(document.getElementById('deleteChat'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(!__props.isTalkRoom ? _unref(translate)('SO65titleConfirmDelete') : _unref(translate)('SO65titleConfirm')), 1),
            _hoisted_6
          ]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(!__props.isTalkRoom ? _unref(translate)('SO65contentConfirmDelete') : _unref(translate)('SO65contentConfirm')), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Button, {
              title: _unref(translate)('cancel'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold me-2'
            }, null, 8, ["title"]),
            _createVNode(Button, {
              title: _unref(translate)('SO65delete'),
              type: 'secondary',
              className: 'fw-bold',
              onClick: deleteMessage,
              loading: loadingSubmit.value,
              disabled: loadingSubmit.value
            }, null, 8, ["title", "loading", "disabled"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h5", _hoisted_13, _toDisplayString(!__props.isTalkRoom ? _unref(translate)('SO65titleConfirmDelete') : _unref(translate)('SO65titleConfirm')), 1),
            _hoisted_14
          ]),
          _createElementVNode("p", _hoisted_15, _toDisplayString(!__props.isTalkRoom
              ? _unref(translate)(handleErrorDelete.value ? 'SO65deleteError' : 'SO65deleteSuccess')
              : _unref(translate)(handleErrorDelete.value ? 'SO65deleteSuccessContentEr' : 'SO65deleteSuccessContent')), 1),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              class: "me-2"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})